import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard";
import { Alert, Col, Row, Spinner } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { basicConfigMultipart } from "../../../constants";
import { localizeDate } from "../../../methods/formatDate";
import CartContainer from "../../cart-page/CartContainer";

const CustomerCart = () => {
  const { pk } = useParams();

  const [loading, setLoading] = useState(true);

  const [showError, setShowError] = useState(false);

  const [cart, setCart] = useState(null);

  async function fetchOpenCart() {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_API_URL}/orders/filter_cart/`,
        {
          customer: pk,
        },
        basicConfigMultipart
      )
      .catch((_) => {})
      .then((response) => {
        if (response && response.status === 200) {
          setCart(response.data);
        }
      });
    setLoading(false);
  }

  useEffect(() => {
    fetchOpenCart();
    //   eslint-disable-next-line
  }, [pk]);

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Customer's Open Shopping Cart</h4>
          </div>

          <Row>
            <Col sm={2}>Line Items : {(cart?.cart_items || []).length}</Col>
            <Col sm={3}>
              Date Created :{" "}
              {cart?.date_created_gmt != null &&
                localizeDate(cart?.date_created_gmt)}{" "}
            </Col>
            <Col sm={4}>
              Last Modified :{" "}
              {cart?.date_modified_gmt != null &&
                localizeDate(cart?.date_modified_gmt)}{" "}
            </Col>
            <Col sm={3}>
              <Link to={`/admin/mail/${pk}`}>Send Mail</Link>
            </Col>
          </Row>
          <br />

          <div className="admin_content_content">
            {(cart?.cart_items || []).map((item, index) => {
              return (
                <CartContainer key={index} item={item} modifiable={false} />
              );
            })}
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default CustomerCart;
